import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { grey40, white, blue } from 'Styles/colors';

export const ProgressBar = styled.div`
  background-color: ${grey40};
  height: 8px;
  position: relative;

  &:before {
    border-right: 2px solid ${grey40};
    border-top: 4px solid ${white};
    border-bottom: 4px solid ${white};
    content: '';
    position: absolute;
    left: 0;
  }

  &:after {
    border-left: 2px solid ${grey40};
    border-top: 4px solid ${white};
    border-bottom: 4px solid ${white};
    content: '';
    position: absolute;
    right: 0;
  }
`;

export const Fill = styled.span`
  position: absolute;
  left: 0;
  height: 100%;
  background-color: ${blue};
  transition: width 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
  overflow: hidden;

  ${({ fillPercent }) => css`
    width: ${ifProp('loaded', `${fillPercent}%`, 0)};
  `}

  ${({ fillPercent }) =>
    fillPercent > 1 &&
    css`
      &:before {
        border-right: 2px solid ${blue};
        border-top: 4px solid ${white};
        border-bottom: 4px solid ${white};
        content: '';
        position: absolute;
        left: 0;
      }

      &:after {
        border-style: solid;
        border-right-style: none;
        border-left: 2px solid ${blue};
        border-top-width: 4px;
        border-top-color: ${ifProp({ fillPercent: 100 }, white, grey40)};
        border-bottom-width: 4px;
        border-bottom-color: ${ifProp({ fillPercent: 100 }, white, grey40)};

        content: '';
        position: absolute;
        right: 0;
      }
    `}
`;
